import {createContext, useState} from "react";

export const ForeignerRegisterContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [register, setRegister] = useState(null);
    const [registers, setRegisters] = useState([]);
    const [registerDialog, setRegisterDialog] = useState(false);

    // Make the context object:
    const foreignerRegisterContext = {
        register,
        setRegister,
        registers,
        setRegisters,
        registerDialog,
        setRegisterDialog,
    };

    // pass the value in provider and return
    return <ForeignerRegisterContext.Provider value={foreignerRegisterContext}>{children}</ForeignerRegisterContext.Provider>;
}

export const {Consumer} = ForeignerRegisterContext;
